import { render, staticRenderFns } from "./point-history.vue?vue&type=template&id=b255c2bc&scoped=true&"
import script from "./point-history.vue?vue&type=script&lang=js&"
export * from "./point-history.vue?vue&type=script&lang=js&"
import style0 from "./point-history.vue?vue&type=style&index=0&id=b255c2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b255c2bc",
  null
  
)

export default component.exports